import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import './collaborator.css';


class Collaborator extends React.Component {


  static propTypes = {
    name: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired,
    sponsor: PropTypes.bool.isRequired,
    url: PropTypes.string.isRequired
  }

  static defaultProps = {
    name: "Georgia Tech",
    logo: "",
    sponsor: false,
    url: "#"
  }

  render() {

    return (
        <div className={"collaborator-container col-xs-6 col-sm-4 col-md-4 col-lg-3 col-xl-3"}>
          <div className="collaborator">
            <a href={this.props.url} target="_blank">
              <img src={this.props.logo} alt={this.props.name}/>
            </a>
          </div>
        </div>
    )
  }
}

export default Collaborator;



// WEBPACK FOOTER //
// ./src/components/Collaborator/collaborator.js